module.exports = __webpack_public_path__ + "static/power2-1-2c857a4a7ef144b5ca94963db0b7b6e4.png";